import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './spinner.css';

const Spinner = (props) => {
    const {
        size,
        className,
        children,
        ...other
    } = props;

    const container = cx({
        [`${style.xl}`]: size === 'xlarge',
        [`${style.lg}`]: size === 'large',
        [`${style.sm}`]: size === 'small'
    });

    return (
        <span className={container}>
			<span
                className={`flex align-item-center justify-content-ce ${style.spinner} ${className}`} {...other} >
				{children}
			</span>
		</span>);
};

Spinner.propTypes = {
    /**
     * size of the spinner
     */
    size: PropTypes.oneOf(['small', 'large', 'xlarge']),
    /**
     * css class names
     */
    className: PropTypes.string,

    /**
     * children
     */
    children: PropTypes.node
};

Spinner.defaultProps = {
    size: 'small',
    className: '',
    children: null
};

export default Spinner;